module.exports = __webpack_public_path__ + "static/media/hospital.d559cdb2.svg";